import { api } from '@/core/api';

const URL = '/api/bidQuestionConfig';

export const get = (params) => api.get(URL, { params });
export const getById = (id) => api.get(`${URL}/${id}`);
export const getSections = (id) => api.get(`${URL}/${id}/sections`);
export const save = (payload) => api.post(`${URL}/`, payload);
export const getAnswersTypes = () => api.get(`${URL}/answertypes`);
export const getSectionTypes = () => api.get(`${URL}/sectiontypes`);
export const update = (id, payload) => api.put(`${URL}/${id}`, payload);
export const changeStatus = (id, statusId) =>
  api.put(`${URL}/${id}/changestatus/${statusId}`);
export const remove = (id) => api.delete(`${URL}/${id}`);
